import { Component, computed, signal, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitleService } from '@core/services/title.service';
import { LoaderComponent } from '@shared/components/loader.component';
import { ToasterComponent } from '@shared/components/toaster.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, ToasterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ai-chatbot';
  titleService = inject(TitleService);

  /** Shows redirect overlay until app init is complete */
  showRedirectOverlay = signal(true);

  constructor() {
    // Simulate a delay, or trigger this after some service initializes
    setTimeout(() => {
      this.showRedirectOverlay.set(false);
    }, 1500); // Adjust timing as needed or bind to real readiness
  }
}
